import { Select, Table, Row, Col, Empty, Steps, Badge, Button } from 'antd';
import React, { useContext, useEffect, useState } from 'react';
import {
  getExamsAsTeacher,
  getTeacherStudentsExamResults,
  getTeachersSubjects,
  getGroupsWithTeacherId,
  getGroupsWithStudentId,
  getTeacherExamsByFilter,
  getStudentAnswers,
  getUserRole,
  getStudentExamsByFilter
} from '../../../actions';
import { Context } from '../../../defaults';

import Question from './question';
const { Step } = Steps;


function ExamResults() {
  const { dictionary, language, setLoading } = useContext(Context);
  const [students, setStudents] = useState([]);
  const [current, setCurrent] = useState(0);
  const [subjectsList, setSubjectsList] = useState();
  const [groupsList, setGroupList] = useState();
  const [selectedExam, setSelectedExam] = useState({});
  const [examsList, setExams] = useState();
  const [question, setQuestion] = useState({});
  const [filters, setFilters] = useState({ groupId: null, subjectId: null, showTable: false });
  const [student, setStudent] = useState({});
  const [role, setRole] = useState();


  const next = () => {
    setCurrent(current + 1);
  };

  const done = () => {
    setSelectedExam({});
    setQuestion({});
    setCurrent(0);
  }

  const setIndex = (index) => {
    setCurrent(index);
  }

  const prev = () => {
    setCurrent(current - 1);
  };

  useEffect(() => {
    getUserRole().then((res) => {
      setRole(res.data);

      if (res.data === "teacher") {
        getTeachersSubjects().then(({ data }) => setSubjectsList(data));
        getGroupsWithTeacherId().then(({ data }) => setGroupList(data));
      } else {
        getGroupsWithStudentId().then(({ data }) => setGroupList(data));
      }
    });
  }, []);

  useEffect(() => {
    if (selectedExam.examId) {
      setLoading(true);
      getStudentAnswers(
        selectedExam.examId,
        selectedExam.questionIds[current]
      ).then((res) => {
        setLoading(false);
        setQuestion({
          ...res.data,
          studentAnswer: {
            ...res.data.studentAnswer,
            isRight: res.data.studentAnswer.isRight || 0,
          },
        });
      });
    }
  }, [selectedExam, current]);

  function getFilteredExamsList(groupId) {
    if (role === "teacher") {
    getTeacherExamsByFilter({ ...filters, groupId }).then(({ data }) => setExams(data));
    } else {
      console.log("aaaa",groupId);
      getStudentExamsByFilter(groupId).then(({data}) => setExams(data));
    }
  }

  function getExamResultsById(examId) {
    //setSelectedExam(examsList.filter(x=>x.id === examId));
    getTeacherStudentsExamResults(examId).then((res) => {
      setStudents(res.data);
      setFilters({ ...filters, showTable: true });
    });
  }

  function doSomethin(item) {
    setCurrent(0);
    setSelectedExam(item);
    getStudentAnswers(item.examId, item.questionIds[current]).then(res => {
      setQuestion(res.data);
    });
  }

  const columns = [
    {
      title: dictionary?.LastName[language],
      dataIndex: 'lastName',
      key: 'lastName',
      render: (text) => text,
    },
    {
      title: dictionary?.FirstName[language],
      dataIndex: 'firstName',
      key: 'firstName',
    },
    {
      title: dictionary?.MiddleName[language],
      dataIndex: 'middleName',
      key: 'middleName',
    },
    {
      title: dictionary?.VariantNumber[language],
      dataIndex: 'variantNumber',
      key: 'variantNumber',
    },
    {
      title: dictionary?.Score[language],
      key: 'score',
      dataIndex: 'score',
    },
    {
      title: dictionary?.MaxPoint[language],
      key: 'maxPoint',
      dataIndex: 'maxPoint',
    },
    {
      title: dictionary?.QuestionsList[language],
      key: 'operation',
      fixed: 'right',
      render: (item) => <a onClick={
        () => doSomethin(item)}>Просмотр</a>
    }
  ];

  return (
    <React.Fragment>
      <h1 style={{ textAlign: 'center' }}>{dictionary?.ExamResult[language]}</h1>
      <Row style={{ marginTop: '30px' }} gutter={24}>
        { role === "teacher" && 
        <Col span={8}>
          <Select
            placeholder={dictionary?.Subjects[language]}
            size="large"
            style={{ width: '100%' }}
            allowClear={true}
            showSearch={true}
            onChange={(e) => {
              !!e
                ? setFilters({ ...filters, subjectId: e })
                : setFilters({ ...filters, subjectId: null });
            }}
            filterOption={(search, item) => {
              return item.children.toLowerCase().indexOf(search.toLowerCase()) >= 0;
            }}>
            {subjectsList &&
              subjectsList.map((el) => {
                return (
                  <Select.Option value={el.id} key={el.id}>
                    {el.name}
                  </Select.Option>
                );
              })}
          </Select>
        </Col> }


        <Col span={8}>
          <Select
            placeholder={dictionary?.Group[language]}
            size="large"
            style={{ width: '100%' }}
            allowClear={true}
            showSearch={true}
            //disabled={!filters.subjectId}
            filterOption={(search, item) => {
              return item.children.toLowerCase().indexOf(search.toLowerCase()) >= 0;
            }}
            onChange={(e) => {
              !!e
                ? setFilters({ ...filters, groupId: e })
                : setFilters({ ...filters, groupId: null });
              !!e && getFilteredExamsList(e);
            }}>
            {groupsList &&
              groupsList.map((el) => {
                return (
                  <Select.Option value={el.id} key={el.id}>
                    {el.name}
                  </Select.Option>
                );
              })}
          </Select>
        </Col>
        <Col span={8}>
          <Select
            placeholder={dictionary?.ExamsList[language]}
            size="large"
            style={{ width: '100%' }}
            allowClear={true}
            showSearch={true}
            //disabled={!filters.subjectId || !filters.groupId}
            filterOption={(search, item) => {
              return item.children.toLowerCase().indexOf(search.toLowerCase()) >= 0;
            }}
            onChange={(e) => {
              !!e && getExamResultsById(e);
              !e && setFilters({ ...filters, showTable: false });
            }}>
            {examsList &&
              examsList.map((el) => {
                return (
                  <Select.Option value={el.id} key={el.id}>
                    {el.name}
                  </Select.Option>
                );
              })}
          </Select>
        </Col>
      </Row>
      {students && students.length > 0
        ? filters.showTable && (
          <Table
            style={{ marginTop: 50 }}
            columns={columns}
            dataSource={students}
            rowKey={'studentId'}
          />
        )
        : filters.showTable && (
          <Empty style={{ marginTop: 50 }} description="По выбранному экзамену еще нету данных" />
        )}

      <Steps current={current} style={{ marginTop: 24 }} size="small">
        {selectedExam.questionIds &&
          selectedExam.questionIds.map((_, index) => {
            return <Step key={`question${index}`} style={{ cursor: 'pointer' }} onClick={() => setIndex(index)} />;
          })}
      </Steps>
      {question.question && question.question.id && (
        <Badge.Ribbon
          text={`${dictionary?.QuestionLevel[language]} - ${question.question.questionLevel}`}
        >
          <div className="steps-content">
            <div className="site-drawer-render-in-current-wrapper">
              <Question
                data={question}
                setData={setQuestion}
                student={student}
                current={current}
              />
            </div>
          </div>
        </Badge.Ribbon>
      )}
      <div className="steps-action">
        {current < selectedExam?.questionIds?.length - 1 && (
          <Button type="primary" onClick={() => next()}>
            {dictionary?.Next[language]}
          </Button>
        )}
        {current === selectedExam?.questionIds?.length - 1 && (
          <Button type="primary" onClick={() => done()}>
            {dictionary?.LogOut[language]}
          </Button>
        )}
        {current > 0 && (
          <Button style={{ margin: "0 8px" }} onClick={() => prev()}>
            {dictionary?.Previous[language]}
          </Button>
        )}
      </div>
    </React.Fragment>
  );
}

export default ExamResults;
